
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../BaseUrl";
import { toastError, toastSuccess } from "../../AlertMessage/AlertMessage";

// Get Table Data
export const PlantationDetailsPartTwoTableDataAPI = createAsyncThunk("PlantationDetailsPartTwoTableData", async ({ data }) => {
    const {
        FinancialYearID,
        MonthsID,
        M_BeneficiaryDetailsID,
        M_TableUserMasterID,
        Flag,
        handleGetFormData,
        setPlantationDetails,
        setReplacedDeadSampling,
        setKeepingQualityHomeData,
        setReasonForDeath,
        handleSetData,

        token
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Transaction/Get_APK_T_BeneficiaryPlantationDetails_2_Select?FinancialYearID=${FinancialYearID}&MonthsID=${MonthsID}&M_BeneficiaryDetailsID=${M_BeneficiaryDetailsID}&M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data && result.data.table) {

                if (Flag == "PlantationPart2") {
                    setPlantationDetails(result.data.table)
                    // sessionStorage.setItem('T_BeneficiaryPlantationDetailsID',result.data.table[0].t_BeneficiaryPlantationDetailsID)
                } if (Flag == "ReplacedDeadSapling") {
                    setReplacedDeadSampling(result.data.table)
                } if (Flag == 'KeepingPlanAtHome') {
                    // console.log("result",result.data.table)
                    setKeepingQualityHomeData(result.data.table)
                    handleSetData && handleSetData(result.data.table)
                } if (Flag == 'ReasonForDeath') {
                    // console.log("result",result.data.table)
                    setReasonForDeath(result.data.table)
                    handleSetData && handleSetData(result.data.table)
                }
                return result.data.table

            } else {
                // toastError(result.message)

                if (Flag == "PlantationPart2") {
                    setPlantationDetails([])

                } if (Flag == "ReplacedDeadSapling") {
                    setReplacedDeadSampling([])
                } if (Flag == 'KeepingPlanAtHome') {
                    // console.log("result",[])
                    setKeepingQualityHomeData([])
                    handleSetData && handleSetData([])
                } if (Flag == 'ReasonForDeath') {
                    // console.log("result",[])
                    setReasonForDeath([])
                    handleSetData && handleSetData([])
                }
                return result
            }
        })
})

const PlantationDetailsPartTwoTableDataSlice = createSlice({
    name: "PlantationDetailsPartTwoTableData",
    initialState: {
        isFirstPartLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PlantationDetailsPartTwoTableDataAPI.pending, (state, action) => {
            state.isFirstPartLoading = true;
        });
        builder.addCase(PlantationDetailsPartTwoTableDataAPI.fulfilled, (state, action) => {
            state.isFirstPartLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(PlantationDetailsPartTwoTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isFirstPartLoading = false;
            state.isError = true;
            state.tableData = null;
            toastError('Something went wrong')
        });
    },
})

export const PlantationDetailsPartTwoTableDataReducer = PlantationDetailsPartTwoTableDataSlice.reducer

// --------------------Keeping plants at home Post API---------------------

export const KeepingPlantsAtHomePostAPI = createAsyncThunk("KeepingPlantsAtHomePost", async ({ data }) => {
    const {
        FinancialYearID,
        MonthsID,
        M_BeneficiaryDetailsID,
        RawData,
        Reason,
        M_TableUserMasterID,
        token,
        handleDataIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("FinancialYearID", FinancialYearID);
    formdata.append("MonthsID", MonthsID);
    formdata.append("M_BeneficiaryDetailsID", M_BeneficiaryDetailsID);
    formdata.append("RawData", RawData);
    formdata.append("Reason", Reason);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/Post_APK_T_BeneficiaryPlantationDetails_KeepingPlanAtHome_Insert`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.status) {
                handleDataIsPost()
                toastSuccess(result.message)
            } else {
                toastError(result.message)
            }
            return result
        })
})

const KeepingPlantsAtHomePostSlice = createSlice({
    name: "KeepingPlantsAtHomePost",
    initialState: {
        isPostLoading: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(KeepingPlantsAtHomePostAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(KeepingPlantsAtHomePostAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.PostData = action.payload;
        });
        builder.addCase(KeepingPlantsAtHomePostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.PostData = null;

        });
    },
})

export const KeepingPlantsAtHomePostReducer = KeepingPlantsAtHomePostSlice.reducer


// --------------------dead samplings Post API---------------------

export const DeadSamplingsPostAPI = createAsyncThunk("DeadSamplingsPost", async ({ data }) => {
    const {
        FinancialYearID,
        MonthsID,
        M_BeneficiaryDetailsID,
        ReplacedDeadSaplings_M_IndicatorID,
        ReplacedDeadSaplingsSub_M_IndicatorID,
        Quantity,
        IsCoverLosses_M_IndicatorID,
        YesNo_M_IndicatorID,
        Remark,
        M_TableUserMasterID,
        token,
        handleDataIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("FinancialYearID", FinancialYearID);
    formdata.append("MonthsID", MonthsID);
    formdata.append("M_BeneficiaryDetailsID", M_BeneficiaryDetailsID);
    formdata.append("ReplacedDeadSaplings_M_IndicatorID", ReplacedDeadSaplings_M_IndicatorID);
    formdata.append("ReplacedDeadSaplingsSub_M_IndicatorID", ReplacedDeadSaplingsSub_M_IndicatorID);
    formdata.append("Quantity", Quantity);
    formdata.append("IsCoverLosses_M_IndicatorID", IsCoverLosses_M_IndicatorID);
    formdata.append("YesNo_M_IndicatorID", YesNo_M_IndicatorID);
    formdata.append("Remark", Remark);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/Post_APK_T_BeneficiaryPlantationDetails_ReplacedDeadSapling_Insert`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.status) {
                handleDataIsPost()
                toastSuccess(result.message)
            } else {
                toastError(result.message)
            }
            return result
        })
})

const DeadSamplingsPostSlice = createSlice({
    name: "DeadSamplingsPost",
    initialState: {
        isPostLoading: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(DeadSamplingsPostAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(DeadSamplingsPostAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.PostData = action.payload;
        });
        builder.addCase(DeadSamplingsPostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.PostData = null;

        });
    },
})

export const DeadSamplingsPostReducer = DeadSamplingsPostSlice.reducer



// InsertUpdate Table Data
export const PlantationDetailsPartTwoPostAPI = createAsyncThunk("PlantationDetailsPartTwoPost", async ({ data }) => {
    const {
        FinancialYearID,
        MonthsID,
        T_BeneficiaryPlantationDetailsID,
        M_BeneficiaryDetailsID,
        SuppliedAtRightTime_M_IndicatorID,
        SuppliedAtRightTime,
        SaplingScheme_M_IndicatorID,
        CasualtyReplacement_M_IndicatorID,
        ReplacedDeadSapling_M_IndicatorID,
        ReasonForDeath_M_IndicatorID,
        ReasonForDeath,
        KeepingPlantsathome_M_IndicatorID,
        QualityOfPlantationl_M_IndicatorID,
        QualityOfPlantationl_One,
        QualityOfPlantationl_Two,
        QualityOfPlantationl_Three,
        M_TableUserMasterID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("FinancialYearID", FinancialYearID);
    formdata.append("MonthsID", MonthsID);
    formdata.append("T_BeneficiaryPlantationDetailsID", T_BeneficiaryPlantationDetailsID);
    formdata.append("M_BeneficiaryDetailsID", M_BeneficiaryDetailsID);
    formdata.append("SuppliedAtRightTime_M_IndicatorID", SuppliedAtRightTime_M_IndicatorID);
    formdata.append("SuppliedAtRightTime", SuppliedAtRightTime);
    formdata.append("SaplingScheme_M_IndicatorID", SaplingScheme_M_IndicatorID);
    formdata.append("CasualtyReplacement_M_IndicatorID", CasualtyReplacement_M_IndicatorID);
    formdata.append("ReplacedDeadSapling_M_IndicatorID", ReplacedDeadSapling_M_IndicatorID);
    formdata.append("ReasonForDeath_M_IndicatorID", ReasonForDeath_M_IndicatorID);
    formdata.append("ReasonForDeath", ReasonForDeath);
    formdata.append("KeepingPlantsathome_M_IndicatorID", KeepingPlantsathome_M_IndicatorID);
    formdata.append("QualityOfPlantationl_M_IndicatorID", QualityOfPlantationl_M_IndicatorID);
    formdata.append("QualityOfPlantationl_One", QualityOfPlantationl_One);
    formdata.append("QualityOfPlantationl_Two", QualityOfPlantationl_Two);
    formdata.append("QualityOfPlantationl_Three", QualityOfPlantationl_Three);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "PATCH",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/APK_T_BeneficiaryPlantationDetails_2_Update`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.status) {
                handleIsPost()
                toastSuccess(result.message)
            } else {
                toastError("Something went wrong")
            }
            return result
        })
})

const PlantationDetailsPartTwoPostSlice = createSlice({
    name: "BeneficiaryPost",
    initialState: {
        isPostLoading: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PlantationDetailsPartTwoPostAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(PlantationDetailsPartTwoPostAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.PostData = action.payload;
        });
        builder.addCase(PlantationDetailsPartTwoPostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.PostData = null;
            // toastError('Something went wrong')

        });
    },
})

export const PlantationDetailsPartTwoPostReducer = PlantationDetailsPartTwoPostSlice.reducer

// ------------------------------ Dead Samplings -------------------------------

export const DeadSamplingsDeleteAPI = createAsyncThunk("DeadSamplingsDelete", async ({ data }) => {
    const {
        T_BeneficiaryPlantationDetails_ReplacedDeadSaplingID,
        M_TableUserMasterID,
        token,
        handleIsReplacedDeadSamplingData,
        handleShowDelete
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_BeneficiaryPlantationDetails_ReplacedDeadSaplingID", T_BeneficiaryPlantationDetails_ReplacedDeadSaplingID);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "DELETE",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/Web_T_BeneficiaryPlantationDetails_ReplacedDeadSapling_Delete`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if ((result.code >= 200 && result.code <= 300) && result.status) {
                // console.log(result.message)
                toastSuccess(result.message)
                handleIsReplacedDeadSamplingData()
                handleShowDelete()
            } else {
                toastError(result.message)
            }
            return result
        })
})

const DeadSamplingsDeleteSlice = createSlice({
    name: "DeadSamplingsDelete",
    initialState: {
        isDeleteLoading: false,
        DeleteData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(DeadSamplingsDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(DeadSamplingsDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.DeleteData = action.payload;
        });
        builder.addCase(DeadSamplingsDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.DeleteData = null;

        });
    },
})

export const DeadSamplingsDeleteReducer = DeadSamplingsDeleteSlice.reducer

// ------------------------------ Keeping plants at home -------------------------------

export const KeepingPlantsDeleteAPI = createAsyncThunk("KeepingPlantsDelete", async ({ data }) => {
    const {
        T_BeneficiaryPlantationDetails_KeepingPlanAtHomeID,
        M_TableUserMasterID,
        token,
        handleDataIsPost,
        handleShowDelete
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_BeneficiaryPlantationDetails_KeepingPlanAtHomeID", T_BeneficiaryPlantationDetails_KeepingPlanAtHomeID);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "DELETE",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/Web_T_BeneficiaryPlantationDetails_KeepingPlanAtHome_Delete`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if ((result.code >= 200 && result.code <= 300) && result.status) {
                // console.log(result.message)
                toastSuccess(result.message)
                handleDataIsPost()
                handleShowDelete()
            } else {
                toastError(result.message)
            }
            return result
        })
})

const KeepingPlantsDeleteSlice = createSlice({
    name: "KeepingPlantsDelete",
    initialState: {
        isDeleteLoading: false,
        DeleteData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(KeepingPlantsDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(KeepingPlantsDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.DeleteData = action.payload;
        });
        builder.addCase(KeepingPlantsDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.DeleteData = null;

        });
    },
})

export const KeepingPlantsDeleteReducer = KeepingPlantsDeleteSlice.reducer


